import type { ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';
import { CURATED_HOMEPAGE_MAX_LINKS_PER_SECTION, DEFAULT_MAX_LINKS_PER_SECTION } from '../seoLinksLimits';
import styles from './LinkSection.module.scss';

type LinkSectionProps = {
  heading: string;
  links: SeoLinkItem[];
  limit?: number;
  showMoreToggle?: ReactNode;
};

const LinkSection = ({ heading, links, limit = DEFAULT_MAX_LINKS_PER_SECTION, showMoreToggle }: LinkSectionProps) => {
  const [firstColumnLinks, secondColumnLinks] =
    limit === CURATED_HOMEPAGE_MAX_LINKS_PER_SECTION ? [links.slice(0, 25), links.slice(25, 50)] : [links.slice(0, 8), links.slice(8, 15)];

  return (
    <div className={styles.container}>
      <Typography variant="heading200" component="div" className={styles.header}>
        {heading}
      </Typography>
      <div className={styles.columnedSection}>
        <ul className={styles.linksColumn}>
          {firstColumnLinks.map(link => (
            <li key={link.url} className={styles.listItem}>
              <Link href={link.url} size="sm" variant="secondary" noUnderline>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
        <ul className={styles.linksColumn}>
          {secondColumnLinks.map(link => (
            <li key={link.url} className={styles.listItem}>
              <Link href={link.url} size="sm" variant="secondary" noUnderline>
                {link.title}
              </Link>
            </li>
          ))}
          {showMoreToggle && (
            <li className={styles.listItem} key="seo-links-show-more-toggle">
              {showMoreToggle}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default LinkSection;
